import { arrayOf, node, string, oneOfType } from 'prop-types'

const Table = ({ cssClass = '', children = {} }) => {
  return (
    <table className={`table ${cssClass}`}>
      {children}
    </table>
  )
}

Table.propTypes = {
  children: oneOfType([node, arrayOf([node])]),
  cssClass: string
}

export default Table
